var map = {
	"./brain-twist.webp": 4754,
	"./bulk-sms.webp": 1128,
	"./petentries.webp": 6963,
	"./playtoday-app.webp": 2145,
	"./playtoday-marketplace.webp": 2717,
	"./playtoday-metaverse.webp": 2864,
	"./snaplocker.webp": 3484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;